import React, { useEffect } from 'react';

const useLocalStorage = (key: string, initialValue: unknown) => {
  const [value, setValue] = React.useState(() => {
    const value = localStorage.getItem(key);
    return value
      ? JSON.parse(value)
      : typeof initialValue === 'function'
        ? initialValue()
        : initialValue;
  });

  useEffect(() => {
    if (value === null || value === undefined) {
      localStorage.removeItem(key);
    } else {
      localStorage.setItem(key, JSON.stringify(value));
    }
  }, [key, value]);

  return [value, setValue];
};

export default useLocalStorage;
